<div class="booking-entry relative">
  <cms-disruptions [disruptions]="disruptions$ | async"></cms-disruptions>
  <div *ngIf="!isNewWidget" class="booking-widget-area flex">
    <fin-booking-widget
      class="flex-1"
      [campaignImage$]="campaignImg$"
      [enableAward]="true"
      [enablePromoCode]="true"
      [enableCompactWidget]="true"
      [enableOpenJaw]="true"
    ></fin-booking-widget>
  </div>
  <div *ngIf="isNewWidget" class="pr-xlarge-y bg-container">
    <fin-content-image class="background-image" [imageData$]="backgroundImg$"></fin-content-image>
    <fin-booking-widget-v2 [compactMode]="true"></fin-booking-widget-v2>
  </div>
</div>
